<template>
  <div class="wrap">
    <div class="pop">
      <p class="title">
        <span>{{ruleContent.protocolTitle}}</span>
      </p>
      <div class="content" v-html="getXssIntro(ruleContent.protocolContent)"></div>
      <el-button class="readBtn" type="primary" :disabled="disabled" @click="closePop">{{disabled ?'我已阅读并知晓(' + time +'s)' : '我已阅读并知晓'}}</el-button>
    </div>
  </div>
</template>
<script>
import { getXssIntro } from '@/utils/xss'

export default {
  data () {
    return {
      time: 0,
      timer: null,
      disabled: true,
      ruleContent: {}
    }
  },
  methods: {
    getXssIntro,
    init (ruleContent) {
      this.timer = null
      this.ruleContent = ruleContent
      this.time = ruleContent.showTime
      this.disabled = true
      this.timer = setInterval(() => {
        if (this.time > 0) {
          this.time --
        } else {
          this.disabled = false
          clearInterval(this.timer)
        }
      }, 1000)
    },
    closePop () {
      this.$emit('closePop')
    },
    getContent (type) {
      this.type = type
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
<style lang="less" scoped>
  .wrap{
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.4);
    z-index: 2002;
    .pop {
      width: 900px;
      height: 600px;
      overflow-y: auto;
      background: #fff;
      position: absolute;
      top: calc(50% - 300px);
      left: calc(50% - 400px);
      box-shadow: 0px 12px 30px 0px rgba(0, 0, 0, 0.12);
      border-radius: 4px;
      padding: 0 20px;
      .title {
        text-align: center;
        height: 88px;
        line-height: 88px;
        font-weight: 700;
        color: #222222;
        font-size: 20px;
        margin: 0;
      }
      .content {
        color: #000000;
        height: 416px;
        overflow-y: auto;
        padding: 0 20px;
        /deep/ img{
          max-width: 780px;
        }
      }
      .readBtn {
        display: block;
        width: 176px;
        border-radius: 2px;
        font-size: 14px;
        margin: 24px auto;
      }
      .is-disabled {
        background-color: #a0cfff;
        border-color: #a0cfff;
      }
    }
  }
</style>